<template>
  <ClientOnly>
    <div
      id="home-slider"
      class="carousel slide carousel-fade"
      v-if="slider && slider.slides"
    >
      <div class="left-slider-img">
        <ol class="carousel-indicators d-none">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
          ></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        </ol>
        <div class="carousel-inner">
          <div
            class="carousel-item"
            :class="{ active: index === 0 }"
            v-for="(bSlide, index) in slider.slides"
            :key="index"
          >
            <img
              :src="bSlide.optImage"
              class="d-none d-md-block w-100"
              alt=""
            />
            <img
              :src="bSlide.optImage"
              class="d-block d-md-none w-100"
              alt=""
            />
            <div class="carousel-caption">
              <h5
                class="fw-bold fs-1 mb-4 text-white"
                v-if="bSlide.title && bSlide.title != ''"
              >
                {{ bSlide.title }}
              </h5>
              <v-runtime-template
                v-if="bSlide.description && bSlide.description != ''"
                :template="'<div>' + unescape(bSlide.description) + '</div>'"
              ></v-runtime-template>
              <b-link
                :href="bSlide.link"
                :target="bSlide.link.indexOf('http') != -1 ? '_new' : '_self'"
                v-if="bSlide.link"
              >
                <button href="#" class="btn btn-secondary btn-xl btn-lg">
                  {{ bSlide.buttonText }}
                </button>
              </b-link>
            </div>
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-target="#home-slider"
          data-slide="prev"
        >
          <ClientOnly
            ><i class="fa-solid fa-chevron-left" aria-hidden="true"></i
          ></ClientOnly>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-target="#home-slider"
          data-slide="next"
        >
          <ClientOnly
            ><i class="fa-solid fa-chevron-right" aria-hidden="true"></i
          ></ClientOnly>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </ClientOnly>
</template>

<script>
import ClientOnly from "vue-client-only";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import VRuntimeTemplate from "v-runtime-template";
import { isMobile } from "mobile-device-detect";
import { isTablet } from "mobile-device-detect";
import { isBrowser } from "mobile-device-detect";

export default {
  components: { VRuntimeTemplate, ClientOnly },

  data() {
    return {
      slide: 0,
      sliding: false,
      carouselConf: {
        speed: 1500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        autoplay: true,
        responsive: [
          {
            settings: {
              dots: false,
              infinite: true,
              speed: 1300,
              breakpoint: 600,
              autoplay: true,
              fade: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              dots: false,
              infinite: true,
              speed: 1300,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    slider() {
      let slider = this.$store.getters["sliders/getSliderByIdentifier"]("home");

      if (slider.slides != null) {
        slider.slides.forEach((element) => {
          if (this.mobileCheck == "browser") {
            element.optImage = element.media.url;
          } else if (this.mobileCheck == "tablet") {
            element.optImage = element.media.smaller;
          } else {
            element.optImage = element.media.smallest;
          }
        });
      }

      return slider;
    },
    mobileCheck() {
      if (isBrowser) {
        return "browser";
      }
      if (isMobile && isTablet) {
        return "tablet";
      }
      return "mobile";
    },
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    unescape(str) {
      return str
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "");
    },
  },
};
</script>

<style>
.carousel-control-prev {
  z-index: 99999;
}

.carousel-control-next {
  z-index: 99999;
}
</style>
